import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Subject, switchMap, takeUntil } from 'rxjs';

@Injectable()
export class MatPaginatorLocalized extends MatPaginatorIntl implements OnDestroy {
    private readonly translocoService = inject(TranslocoService);
    private readonly loaded: Subject<void> = new Subject<void>();
    private rangeSeparatorLabel: string;

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        const startIndex = length === 0 || pageSize === 0 ? 0 : page * pageSize + 1;
        const endIndex = length === 0 || pageSize === 0 ? length : Math.min((page + 1) * pageSize, length);
        return `${startIndex} - ${endIndex} ${this.rangeSeparatorLabel} ${length}`;
    };

    constructor() {
        super();

        this.setLabels();
        this.translocoService.langChanges$
            .pipe(
                switchMap((language) => this.translocoService.load(language)),
                takeUntil(this.loaded)
            )
            .subscribe({ 
                next: () => this.setLabels(),
                error: (message) => console.error('Error loading translations for MatPaginatorIntl:', message)
            });
    }

    ngOnDestroy(): void {
        this.loaded.next();
        this.loaded.complete();
        this.changes.complete();
    }

    private setLabels(): void {
        this.itemsPerPageLabel = this.translocoService.translate('shared.paginators.itemsPerPageLabel');
        this.firstPageLabel = this.translocoService.translate('shared.paginators.firstPageLabel');
        this.nextPageLabel = this.translocoService.translate('shared.paginators.nextPageLabel');
        this.previousPageLabel = this.translocoService.translate('shared.paginators.previousPageLabel');
        this.rangeSeparatorLabel = this.translocoService.translate('shared.paginators.rangeSeparator');
        this.lastPageLabel = this.translocoService.translate('shared.paginators.lastPageLabel');
        this.changes.next();
    }
}
